// crewbit-admin/src/lib/withTimeout.ts
//
// Race a Promise against a rejecting timer. Used to bound supabase-js storage
// uploads, which have been observed to hang indefinitely in Safari prod
// without ever firing the underlying fetch — leaving the calling spinner
// stuck forever. Wrapping the upload in this helper guarantees the await
// resolves (or rejects with a labelled timeout) within `ms`.

export function withTimeout<T>(
  p: PromiseLike<T>,
  ms: number,
  label: string,
): Promise<T> {
  return Promise.race([
    Promise.resolve(p),
    new Promise<T>((_, reject) =>
      setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms),
    ),
  ]);
}
